import { Component } from '@angular/core';
import { NavController, Events } from 'ionic-angular';

// Providers
import { ProvidersService } from '../../providers/providers/providers-service';
import { InstructorsService } from '../../providers/instructors/instructors-service';

// Helpers
import { HelperCsvService } from '../../providers/helpers/helper-csv-service';

// Pages
import { InstructorAddEditPage } from '../instructors/instructor-add-edit';

@Component({
  selector: 'page-report-email-list',
  templateUrl: 'report.email-list.html'
})
export class ReportEmailListPage {
  headerData: any;
  instructors:any = [];
  gotRecords:boolean = false;

  constructor(
    public navCtrl: NavController,
    public events: Events,
    public providersService: ProvidersService,
    public instructorsService: InstructorsService,
    public helperCsvService: HelperCsvService
  ) {
    this.headerData = { title: 'Email List' };
    this.getInstructors();
  }

  getInstructors()
  {
    this.instructorsService.getInstructorsByStatus( 'Approved' )
      .subscribe( data => {
        this.instructors = data;
        if ( this.instructors.length > 0 )
        {
          this.gotRecords = true;
        }
      });
      console.log(this.instructors);
  }

  showInstructorAddEditPage( instructor = null )
  {
    this.navCtrl.push( InstructorAddEditPage, {
      instructor: instructor
    });
  }

  createReportCSV()
  {
    this.helperCsvService.exportInstructorList( this.instructors, 'Instructor Email List.csv' );
  }
}


// WEBPACK FOOTER //
// ./src/pages/reports/report.email-list.ts